$(document).on('click', '.js-accordion .js-accordion-item', function(e){

    const accordion_item = $(this);

    if(accordion_item.hasClass('running')){
        return;
    }
    accordion_item.addClass('running');

    if(accordion_item.hasClass('active')){
        /* only click on header */
        if($(e.target).hasClass('accordion-item-header')){
            accordion_item.removeClass('active');
            $('.content', accordion_item).slideUp(function(){
                accordion_item.removeClass('running');
            });
        }else{
            accordion_item.removeClass('running');
        }
    }else{
        const accordion_wrapper = accordion_item.closest('.js-accordion');
        let opened_accordions = accordion_wrapper.find('.js-accordion-item.active');
        opened_accordions.removeClass('active');
        $('.content', opened_accordions).slideUp();
        accordion_item.addClass('active');
        $('.content', this).slideDown(function(){
            accordion_item.removeClass('running');
        });
    }
})
